import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AttachmentModel } from '@core/data-access';

@Component({
  selector: 'portal-signing-confirm-submit-dialog',
  templateUrl: './confirm-submit-dialog.component.html',
  styleUrls: ['./confirm-submit-dialog.component.scss'],
})
export class ConfirmSubmitDialogComponent {
  // attachments: AttachmentModel[];
  attachments: any[];

  constructor(
    private dialogRef: MatDialogRef<ConfirmSubmitDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: { attachments: AttachmentModel[] },
  ) {
    this.attachments = data.attachments || [];
  }

  close(): void {
    this.dialogRef.close();
  }
  submit(): void {
    this.dialogRef.close(true);
  }
}
